import { render, staticRenderFns } from "./shiftManagementMainDialogCreateEmployee.vue?vue&type=template&id=879d96a0&scoped=true"
import script from "./shiftManagementMainDialogCreateEmployee.vue?vue&type=script&lang=js"
export * from "./shiftManagementMainDialogCreateEmployee.vue?vue&type=script&lang=js"
import style0 from "./shiftManagementMainDialogCreateEmployee.vue?vue&type=style&index=0&id=879d96a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879d96a0",
  null
  
)

export default component.exports